import LoginEmail from '../LoginEmail';
import LoginPassword from '../LoginPassword';
import Sso from '../Sso';
import { AuthScreen } from '../types';
import useAuthScreenConteinerVM from './vm';

const AuthScreenContainer = () => {
  const { screen } = useAuthScreenConteinerVM();

  switch (screen) {
    case AuthScreen.SSO:
      return <Sso />;
    case AuthScreen.PASSWORD:
      return <LoginPassword />;
    case AuthScreen.LOGIN:
      return <LoginEmail />;
    default:
      return <LoginEmail />;
  }
};

export default AuthScreenContainer;
